"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _complementary = _interopRequireDefault(require("./complementary"));

var _jvTypography = _interopRequireDefault(require("./jv-typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var jvBaseTheme = {
  name: 'jv-caixa',
  version: '1.0.0',
  color: {
    brandPrimary: {
      dark: '#00377D',
      medium: '#0039BA',
      light: '#005FC8',
      gradient: 'linear-gradient(215.68deg, #87BAFF -80.44%, #005FC8 81.35%)'
    },
    brandSecondary: {
      dark: '#C27300',
      medium: '#F39200',
      light: '#F9B000',
      gradient: 'linear-gradient(224.14deg, #FFA600 -11.69%, #F36800 100%)'
    },
    brandTertiary: {
      dark: '#F36800',
      medium: '#F36800',
      light: '#F36800',
      gradient: 'linear-gradient(224.14deg, #FFA600 -11.69%, #F36800 100%)'
    },
    support: {
      '01': '#4187D7',
      '02': '#FF9141',
      '03': '#FFFFFF'
    },
    neutral: {
      '01': '#231F20',
      '02': '#414042',
      '03': '#808288',
      '04': '#A4A5A9',
      '05': '#C2C3C6',
      '06': '#DBDCDE',
      '07': '#F0F0F1',
      '08': '#FFFFFF'
    },
    feedback: {
      success: '#008254',
      alert: '#FFDD00',
      error: '#900000'
    },
    background: {
      dark: '#231F20',
      light: '#EDF4F6'
    },
    highlight: {
      '01': '#05AFD2',
      '02': '#319283',
      '03': '#8E5C7E',
      '04': '#FCAF17',
      '05': '#4FB852',
      '06': '#FFFFFF',
      '07': '#FFFFFF',
      '08': '#FFFFFF'
    },
    line: {
      dark: '#231F20',
      medium: '#C2C3C6',
      light: '#FFFFFF',
      primary: '#005FC8',
      secondary: '#F39200'
    }
  },
  font: {
    family: {
      highlight: 'Futura Std',
      base: 'Futura Std'
    },
    size: {
      '2xs': '12px',
      xs: '14px',
      sm: '16px',
      md: '18px',
      lg: '20px',
      xl: '24px',
      '2xl': '28px',
      '3xl': '32px',
      '4xl': '36px',
      '5xl': '40px',
      '6xl': '48px',
      '7xl': '64px'
    },
    weight: {
      '3xs': '100',
      '2xs': '200',
      xs: '300',
      sm: '400',
      md: '500',
      lg: '600',
      xl: '700',
      '2xl': '750',
      '3xl': '900'
    },
    decoration: {
      none: 'none',
      italic: 'italic',
      underline: 'underline',
      strikethrough: 'strikethrough'
    },
    transform: {
      none: 'none',
      uppercase: 'uppercase',
      lowercase: 'lowercase',
      capitalize: 'capitalize'
    }
  },
  line: {
    height: {
      sm: 'auto',
      md: '125%',
      lg: '150%',
      xl: '160%',
      '2xl': '175%',
      '3xl': '200%'
    }
  },
  letter: {
    spacing: {
      sm: 'auto',
      md: '1px',
      lg: '2px',
      xl: '3px',
      '2xl': '4px'
    }
  }
};

var jvTheme = _extends({}, jvBaseTheme, (0, _jvTypography["default"])(jvBaseTheme), (0, _complementary["default"])(jvBaseTheme));

var _default = jvTheme;
exports["default"] = _default;